import { render, staticRenderFns } from "./NBHelp.vue?vue&type=template&id=a7db94ce&scoped=true&"
import script from "./NBHelp.vue?vue&type=script&lang=js&"
export * from "./NBHelp.vue?vue&type=script&lang=js&"
import style0 from "./NBHelp.vue?vue&type=style&index=0&id=a7db94ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7db94ce",
  null
  
)

export default component.exports